module.exports = __webpack_public_path__ + "static/media/who-is-learning.b66fda9c.svg";